import { render, staticRenderFns } from "./star-sheet.vue?vue&type=template&id=354d883e&scoped=true&lang=html&"
import script from "./star-sheet.vue?vue&type=script&lang=js&"
export * from "./star-sheet.vue?vue&type=script&lang=js&"
import style0 from "./star-sheet.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./star-sheet.vue?vue&type=style&index=1&id=354d883e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354d883e",
  null
  
)

export default component.exports